<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <card>
          <template slot="header">
            <h4 class="card-title">營業與公休時間設定</h4>
          </template>
          <p>
            設定每週營業時間，若消費者預約取餐時間遇到公休日，介面上將顯示「公休」不允許送單。
          </p>

          <!-- <div v-if="advancedOpeningSetting === true" style="color:#BA0000">
            您的營業時間是進階版設定，目前需洽客服人員進行修改。
          </div> -->

          <!-- <div v-if="advancedOpeningSetting === false" class="row card-body"> -->
          <div class="row card-body">
            <div class="col-md-12">
              <div
                v-for="day of weekDays"
                v-bind:key="day.id"
                class="row card-body"
              >
                <div class="col-md-2" style="margin: 20px 0px 0px 0px;">
                  <h6>{{ day.name }}</h6>
                </div>
                <div class="col-md-3" style="margin: 20px 0px 0px 0px;">
                  <n-switch
                    v-model="openingSetting[day.id].isOpen"
                    color="green"
                  >
                    <i class="now-ui-icons ui-1_check" slot="on"></i>
                    <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                  </n-switch>
                  <label class="col-sm-6 col-form-label">{{
                    openingSetting[day.id].isOpen === false
                      ? "本日公休"
                      : "本日營業"
                  }}</label>
                </div>
                <div class="col-md-5 col-form-label" style="margin: 10px 0px 0px 0px;">
                  <span
                    v-if="
                      openingSetting[day.id].isOpen &&
                        openingSetting[day.id].hours
                    "
                  >
                    <div
                      v-for="(hour, index) in openingSetting[day.id].hours"
                      :key="index"
                    >
                      <el-select
                        class="select-warning"
                        style="width: 120px; margin: 5px 0 0 0;"
                        size="small"
                        placeholder="Single Select"
                        v-model="hour.openTime"
                      >
                        <el-option value="allOpen" label="24 小時"></el-option>
                        <el-option
                          v-for="option of timeOptions"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="option.id"
                        ></el-option>
                      </el-select>
                      <span
                        v-if="
                          openingSetting[day.id].isOpen &&
                            hour.openTime !== 'allOpen'
                        "
                      >
                        <strong style="padding: 0px 0px 0px 2px;"> — </strong>
                        <el-select
                          class="select-warning"
                          style="width: 120px; margin: 5px 0 0 0;"
                          size="small"
                          placeholder="Single Select"
                          v-model="hour.closeTime"
                        >
                          <el-option
                            v-for="option of timeOptions"
                            class="select-primary"
                            :value="option.id"
                            :label="option.name"
                            :key="option.id"
                          ></el-option>
                        </el-select>
                        <span
                          v-if="
                            openingSetting[day.id].isOpen &&
                              hour.openTime !== 'allOpen' &&
                              index !== 0
                          "
                        >
                          <el-button
                            type="danger"
                            size="small"
                            icon="el-icon-delete"
                            class="ml-2"
                            circle
                            v-on:click="deleteHour(day.id, index, hour)"
                          ></el-button>
                        </span>
                      </span>
                    </div>
                  </span>
                  <!-- <span v-else>
                    <span v-if="openingSetting[day.id].isOpen">
                      <el-select
                        class="select-warning"
                        style="width: 120px;"
                        size="small"
                        placeholder="Single Select"
                        v-model="openingSetting[day.id].openTime"
                      >
                        <el-option value="allOpen" label="24 小時"></el-option>
                        <el-option
                          v-for="option of timeOptions"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="option.id"
                        ></el-option>
                      </el-select>
                    </span>

                    <span
                      v-if="
                        openingSetting[day.id].isOpen &&
                          openingSetting[day.id].openTime !== 'allOpen'
                      "
                    >
                      <strong> — </strong>
                      <el-select
                        class="select-warning"
                        style="width: 120px;"
                        size="small"
                        placeholder="Single Select"
                        v-model="openingSetting[day.id].closeTime"
                      >
                        <el-option
                          v-for="option of timeOptions"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="option.id"
                        ></el-option>
                      </el-select>
                    </span>
                  </span> -->
                </div>
                <div
                  class="col-md-2 col-form-label"
                  style="margin: 10px 0 0 0;"
                >
                  <span v-if="openingSetting[day.id].isOpen">
                    <el-button
                      type="primary"
                      size="small"
                      @click.native="addHour(day.id)"
                      round
                      >新增時段</el-button
                    >
                  </span>
                </div>
              </div>
              <div class="text-center">
                <div>
                  <el-button type="success" @click.native="saveOpening()" round
                    >更新營業時間</el-button
                  >
                </div>

                <div
                  v-if="updateStatus === 'updating'"
                  style="margin: 10px 0 0 0;"
                >
                  設定中...
                </div>
                <div
                  v-if="updateStatus === 'success'"
                  style="color:#00BA00; margin: 10px 0 0 0;"
                >
                  設定成功 <i class="now-ui-icons ui-1_check"></i>
                </div>
                <div
                  v-if="updateStatus === 'error'"
                  style="color:#BA0000; margin: 10px 0 0 0;"
                >
                  設定失敗 <i class="now-ui-icons ui-1_simple-remove"></i>
                </div>
              </div>
            </div>
          </div>
        </card>
        <card>
          <template slot="header">
            <h4 class="card-title">設定特定公休日</h4>
          </template>
          <div class="card-body">
            <h5>直接手動新增</h5>
            <p>
              直接選擇日期，點擊「新增特定公休日」後，確認下方公休日列表是否成功新增
            </p>
            <el-row :gutter="20">
              <el-col :md="6">
                <div class="block">
                  <el-date-picker
                    v-model="specialDateInput"
                    type="date"
                    size="small"
                    placeholder="選擇要公休的日期"
                  >
                  </el-date-picker>
                </div>
              </el-col>
              <el-col :md="6">
                <el-button
                  type="primary"
                  @click.native="addSpecialDate()"
                  size="small"
                  :disable="!specialDateInput"
                  >新增特定公休日</el-button
                >
              </el-col>
              <p
                style="color:#BA0000; margin: 10px 0 0 0;"
                v-if="specialDateInputFailed"
              >
                {{ specialDateInputFailed }}
              </p>
            </el-row>
            <h5 style="margin: 20px 0 10px 0;">批次新增</h5>
            <!-- <router-link to="./gaa-users/new" type="success">
                  <n-button type="success">建立 GAA 管理員</n-button>
            </router-link>-->
            <p>
              透過匯入特殊公休日（例如國定假日）即可進行設定，每次匯入會重新覆蓋上次設定。
            </p>
            <p>要刪除特殊公休日，可將公休日從excel移除後，再次匯入即可。</p>
            <el-row :gutter="20">
              <el-col :xs="24" :md="6">
                <el-input
                  v-model="filters[0].value"
                  placeholder="搜尋日期"
                  prefix-icon="el-icon-search"
                  size="small"
                ></el-input>
              </el-col>
              <el-col :xs="24" :md="6">
                <el-button
                  type="primary"
                  @click.native="openImportPage()"
                  size="small"
                  plain
                  >批次匯入特定公休日</el-button
                >
              </el-col>
            </el-row>

            <data-tables
              :data="data"
              :filters="filters"
              :action-col="actionCol"
            >
              <!-- <data-tables :data="data" :filters="filters"> -->
              <el-table-column
                v-for="title in titles"
                :prop="title.prop"
                :label="title.label"
                :key="title.prop"
                sortable="custom"
              ></el-table-column>
            </data-tables>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";

import {
  Checkbox,
  Radio,
  Switch
  // FormGroupInput as FgInput
} from "src/components/index";

export default {
  components: {
    Checkbox,
    Radio,
    // FgInput,
    [Switch.name]: Switch
  },
  data() {
    return {
      specialDateInput: "",
      specialDateInputFailed: "",
      updateStatus: "none",
      timeOptions: [],
      advancedOpeningSetting: false,
      openingSetting: {
        "0": {},
        "1": {},
        "2": {},
        "3": {},
        "4": {},
        "5": {},
        "6": {}
      },
      weekDays: [
        { id: "0", name: "星期日" },
        { id: "1", name: "星期一" },
        { id: "2", name: "星期二" },
        { id: "3", name: "星期三" },
        { id: "4", name: "星期四" },
        { id: "5", name: "星期五" },
        { id: "6", name: "星期六" }
      ],
      data: [],
      titles: [
        {
          prop: "id",
          label: "NO."
        },
        {
          prop: "specialDate",
          label: "特殊營業日期"
        },
        {
          prop: "openingPeriod",
          label: "營業時間"
        }

        // {
        //   prop: "openTime",
        //   label: "營業開始"
        // },
        // {
        //   prop: "closeTime",
        //   label: "營業結束"
        // }
      ],
      actionCol: {
        label: "操作",
        props: {
          align: "center"
        },
        buttons: [
          {
            props: {
              type: "danger",
              icon: "el-icon-delete",
              size: "small",
              round: true
            },
            label: "刪除",
            handler: row => {
              this.deleteSpecialDate(row.id);
            }
          }
        ]
      },
      // actionCol: {
      //   label: "操作",
      //   props: {
      //     align: "center"
      //   },
      //   buttons: [
      //     {
      //       props: {
      //         type: "warning",
      //         icon: "el-icon-edit"
      //       },
      //       label: "管理員列表",
      //       handler: row => {
      //         console.log("the row is ", row);

      //         this.$router.push(`/si-accounts/${row.id}/si-users`);
      //       }
      //     }
      //   ]
      // },
      filters: [
        {
          value: "",
          prop: "specialDate"
        },
        {
          value: []
        }
      ]
    };
  },
  computed: {
    user: function() {
      return this.$store.getters.user;
    }
  },
  mounted() {
    // 設定可選營業時間
    this.initTimeOptions();
    // 設定預設營業時間, 全日開
    this.initOpeningSetting();

    this.getSpecialOpenings();
  },
  methods: {
    addSpecialDate() {
      let self = this;
      this.specialDateInputFailed = "";
      if (this.specialDateInput) {
        let formatInput = moment(
          this.specialDateInput.toISOString(),
          moment.ISO_8601
        ).format("YYYY-MM-DD");
        return axios
          .post(
            `${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${
              this.$route.query.shop_id
            }/opening-special`,
            {
              date: formatInput,
              closeDay: 100
            }
          )
          .then(function() {
            self.getSpecialOpenings();
            self.specialDateInput = '';
          })
          .catch(function(e) {
            this.specialDateInputFailed = e.message;
          });
      }
    },
    deleteSpecialDate(id) {
      let self = this;
      return axios
        .delete(
          `${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${
            this.$route.query.shop_id
          }/opening-special/${id}`
        )
        .then(function() {
          self.getSpecialOpenings();
        });
    },
    deleteHour(dayId, index, hour) {
      if (this.openingSetting[dayId].hours)
        this.openingSetting[dayId].hours.splice(index, 1);
      // console.log('delete hour ' + JSON.stringify(hour));
    },
    addHour(dayId) {
      if (this.openingSetting[dayId].hours) {
        let intDayId = parseInt(dayId, 10);
        this.openingSetting[dayId].hours.push({
          openTime: "0000",
          closeTime: "0000",
          openDay: intDayId,
          closeDay: intDayId
        });
      }
    },
    windowClosing() {
      this.getSpecialOpenings();
    },
    openImportPage: function() {
      // let qs = encodeURI(`?shop=${this.$route.query.shop_id}`);
      // var newWindow = window.open(
      //   `${process.env.VUE_APP_MENU}/opening-upload${qs}`,
      //   "upload-opening-setting",
      //   "width=200,height=100"
      //   // "width=300,location=no,menubar=no"
      // );
      var newWindow = window.open(
        `${process.env.VUE_APP_MENU}/#/shops/import-opening/${
          this.$route.query.shop_id
        }`,
        "",
        "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=1000,height=1000"
      );
      // for same origin
      // newWindow.onbeforeunload = this.windowClosing;

      let self = this;
      // for cross origin
      var timer = setInterval(function() {
        if (newWindow.closed) {
          clearInterval(timer);
          self.windowClosing();
        }
      }, 1000);
    },
    groupBy: function(list, props) {
      return list.reduce((a, b) => {
        (a[b[props]] = a[b[props]] || []).push(b);
        return a;
      }, {});
    },
    initOpeningSetting: function() {
      let self = this;
      return axios
        .get(
          `${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${
            this.$route.query.shop_id
          }/opening`
        )
        .then(response => {
          // console.log("the response data " + JSON.stringify(response));

          // 先group by day
          let dayGroup = self.groupBy(response.data, "openDay");

          for (let i = 0; i < 7; ++i) {
            // 有存設定
            let thisDayGroups = dayGroup[i.toString()];
            if (thisDayGroups) {
              // 現在不判斷是否進階了，全都用進階寫法
              // if (thisDayGroups.length > 1) {

              // self.advancedOpeningSetting = true;
              // break;

              // 特殊設定版本
              // 不允許修改
              self.openingSetting[i.toString()] = {
                isOpen: true,
                hours: []
              };
              for (let j = 0; j < thisDayGroups.length; ++j) {
                let thisDayGroup = thisDayGroups[j];
                if (thisDayGroup.openDay === thisDayGroup.closeDay) {
                  // 同日
                  if (thisDayGroup.openTime === thisDayGroup.closeTime) {
                    // 進階設定還這樣設定代表設定只能有一個
                    // 跳過此設定
                    self.openingSetting[i.toString()].isOpen = false;
                    self.openingSetting[i.toString()].hours = [
                      {
                        openTime: thisDayGroup.closeTime,
                        closeTime: thisDayGroup.closeTime,
                        openDay: thisDayGroup.openDay,
                        closeDay: thisDayGroup.closeDay
                      }
                    ];
                    // self.openingSetting[i.toString()] = {
                    //   isOpen: false,
                    //   closeTime: thisDayGroup.closeTime,
                    //   openDay: thisDayGroup.openDay,
                    //   closeDay: thisDayGroup.closeDay
                    // };
                  } else {
                    self.openingSetting[i.toString()].hours.push({
                      // isOpen: true,
                      openTime: thisDayGroup.openTime,
                      closeTime: thisDayGroup.closeTime,
                      openDay: thisDayGroup.openDay,
                      closeDay: thisDayGroup.closeDay
                    });
                  }
                } else if (thisDayGroup.openDay !== thisDayGroup.closeDay) {
                  // 晚上做到凌晨，跨日
                  if (thisDayGroup.openTime === thisDayGroup.closeTime) {
                    // 進階設定設定全天候，代表設定只能有一個
                    //24hour

                    // self.openingSetting[i.toString()].openTime = "allOpen";
                    self.openingSetting[i.toString()].hours = [
                      {
                        openTime: "allOpen",
                        closeTime: thisDayGroup.closeTime,
                        openDay: thisDayGroup.openDay,
                        closeDay: thisDayGroup.closeDay
                      }
                    ];
                  } else {
                    self.openingSetting[i.toString()].hours.push({
                      // isOpen: true,
                      openTime: thisDayGroup.openTime,
                      closeTime: thisDayGroup.closeTime,
                      openDay: thisDayGroup.openDay,
                      closeDay: thisDayGroup.closeDay
                    });
                  }
                }
              }

              // self.openingSetting[i.toString()] = {
              //   isOpen: i > 3 ? true : false,
              //   openTime: "allOpen",
              //   closeTime: "0000",
              //   openDay: i,
              //   closeDay: i + 1 > 7 ? 0 : i + 1
              // };
              // } else {
              //   // 一般
              //   let thisDayGroup = thisDayGroups[0];
              //   if (thisDayGroup.openDay === thisDayGroup.closeDay) {
              //     // 同日
              //     if (thisDayGroup.openTime === thisDayGroup.closeTime) {
              //       self.openingSetting[i.toString()] = {
              //         isOpen: false,
              //         closeTime: thisDayGroup.closeTime,
              //         openDay: thisDayGroup.openDay,
              //         closeDay: thisDayGroup.closeDay
              //       };
              //     } else {
              //       self.openingSetting[i.toString()] = {
              //         isOpen: true,
              //         openTime: thisDayGroup.openTime,
              //         closeTime: thisDayGroup.closeTime,
              //         openDay: thisDayGroup.openDay,
              //         closeDay: thisDayGroup.closeDay
              //       };
              //     }
              //   } else if (thisDayGroup.openDay !== thisDayGroup.closeDay) {
              //     // 晚上做到凌晨，跨日
              //     if (thisDayGroup.openTime === thisDayGroup.closeTime) {
              //       //24hour
              //       self.openingSetting[i.toString()] = {
              //         isOpen: true,
              //         openTime: "allOpen",
              //         // openTime: thisDayGroup.openTime,
              //         closeTime: thisDayGroup.closeTime,
              //         openDay: thisDayGroup.openDay,
              //         closeDay: thisDayGroup.closeDay
              //       };
              //     } else {
              //       self.openingSetting[i.toString()] = {
              //         isOpen: true,
              //         openTime: thisDayGroup.openTime,
              //         closeTime: thisDayGroup.closeTime,
              //         openDay: thisDayGroup.openDay,
              //         closeDay: thisDayGroup.closeDay
              //       };
              //     }
              //   }
              // }
            } else {
              // 預設
              this.openingSetting[i.toString()] = {
                // isOpen: i > 3 ? true : false,
                isOpen: true,
                hours: [
                  {
                    openTime: "allOpen",
                    closeTime: "0000",
                    openDay: i,
                    closeDay: i + 1 > 7 ? 0 : i + 1
                  }
                ]
              };
            }
          }
          return response.data;
        });
    },
    initTimeOptions: function() {
      this.timeOptions = [
        // {
        //   id: "allOpen",
        //   name: "24 小時"
        // }
      ];
      for (let i = 0; i < 24; ++i) {
        let tmp = moment({ hour: i, minute: 0 });
        this.timeOptions.push({
          id: tmp.format("HHmm"),
          name: tmp.format("HH:mm")
        });
        let tmp2 = moment({ hour: i, minute: 30 });
        this.timeOptions.push({
          id: tmp2.format("HHmm"),
          name: tmp2.format("HH:mm")
        });
      }
    },
    saveOpening: function(event) {
      let _this = this;
      let params = [];
      this.updateStatus = "updating";

      for (let day in _this.openingSetting) {
        let dayObj = _this.openingSetting[day];
        let tmp = {};

        if (dayObj.isOpen === false) {
          // 非營業日，要注意前一天是幾點打烊?
          let checkDay =
            dayObj.hours[0].openDay - 1 < 0 ? 0 : dayObj.hours[0].openDay - 1;

          let previousDayCloseDay =
            _this.openingSetting[checkDay.toString()].hours[0].closeDay;
          let previousDayCloseTime =
            _this.openingSetting[checkDay.toString()].hours[0].closeTime;
          // tmp.openTime = dayObj.closeTime = dayObj.openTime =
          //   _this.openingSetting[checkDay.toString()].closeTime || "0000";
          for (
            let j = 1;
            j < _this.openingSetting[checkDay.toString()].hours;
            ++j
          ) {
            if (
              previousDayCloseDay !==
                _this.openingSetting[checkDay.toString()].hours[0].closeDay &&
              _this.openingSetting[checkDay.toString()].hours[0].closeDay !==
                checkDay
            ) {
              previousDayCloseDay =
                _this.openingSetting[checkDay.toString()].hours[0].closeDay;
              previousDayCloseTime =
                _this.openingSetting[checkDay.toString()].hours[0].closeTime;
            } else {
              let comingClose = parseInt(
                _this.openingSetting[checkDay.toString()].hours[0].closeTime,
                10
              );
              let nowClose = parseInt(previousDayCloseTime, 10);
              if (comingClose > nowClose) {
                previousDayCloseTime =
                  _this.openingSetting[checkDay.toString()].hours[0].closeTime;
              }
            }
          }
          tmp.openTime = tmp.closeTime = previousDayCloseTime;
          tmp.closeDay = tmp.openDay = dayObj.hours[0].openDay;
          params.push(tmp);
        } else {
          for (let hour of dayObj.hours) {
            tmp = {};
            tmp.openTime = hour.openTime;
            if (hour.openTime === "allOpen") {
              // dayObj.openTime = '0000';
              hour.closeTime = "0000";

              hour.closeDay = hour.openDay + 1 > 7 ? 0 : hour.openDay + 1;

              tmp.openTime = "0000";
            } else {
              if (parseInt(hour.closeTime, 10) > parseInt(hour.openTime, 10)) {
                hour.closeDay = hour.openDay;
              } else {
                hour.closeDay = hour.openDay + 1 > 7 ? 0 : hour.openDay + 1;
              }
            }
            tmp.openDay = hour.openDay;
            tmp.closeDay = hour.closeDay;
            tmp.closeTime = hour.closeTime;
            console.log("raw the close day result " + JSON.stringify(hour));
            console.log("check the close day result " + JSON.stringify(tmp));
            params.push(tmp);
          }
        }

        // 把一些參數調整好 --- 舊版本
        // for (let day in _this.openingSetting) {
        //   let dayObj = _this.openingSetting[day];
        //   let tmp = {};
        //   tmp.openTime = dayObj.openTime;
        //   if (dayObj.isOpen === false) {
        //     // 非營業日，要注意前一天是幾點打烊?
        //     let checkDay = dayObj.openDay - 1 < 0 ? 0 : dayObj.openDay - 1;
        //     tmp.openTime = dayObj.closeTime = dayObj.openTime =
        //       _this.openingSetting[checkDay.toString()].closeTime || "0000";
        //     dayObj.closeDay = dayObj.openDay;
        //   } else {
        //     if (dayObj.openTime === "allOpen") {
        //       // dayObj.openTime = '0000';
        //       dayObj.closeTime = "0000";
        //       dayObj.closeDay = dayObj.openDay + 1 > 7 ? 0 : dayObj.openDay + 1;
        //       tmp.openTime = "0000";
        //     } else {
        //       if (
        //         parseInt(dayObj.closeTime, 10) > parseInt(dayObj.openTime, 10)
        //       ) {
        //         dayObj.closeDay = dayObj.openDay;
        //       } else {
        //         dayObj.closeDay = dayObj.openDay + 1 > 7 ? 0 : dayObj.openDay + 1;
        //       }
        //     }
        //   }

        //   tmp.openDay = dayObj.openDay;
        //   tmp.closeDay = dayObj.closeDay;
        //   tmp.closeTime = dayObj.closeTime;
        //   params.push(tmp);
      }

      return axios
        .put(
          `${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${
            this.$route.query.shop_id
          }/opening`,
          params
        )
        .then(response => {
          console.log("the data " + JSON.stringify(response.data));
          this.updateStatus = "success";
          this.initOpeningSetting();
          return response.data;
        })
        .catch(e => {
          this.updateStatus = "error";
        });
    },
    handleClick(command) {
      this.$message(`click dropdown button ${command}`);
    },
    getSpecialOpenings() {
      // 特殊營業日
      return axios
        .get(
          `${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${
            this.$route.query.shop_id
          }/opening-special`
        )
        .then(response => {
          // this.data = response.data;
          console.log("the sp data " + JSON.stringify(this.data));
          let renderData = [];
          for (let a of response.data) {
            renderData.push({
              id: a.id,
              specialDate: a.specialDate,
              openingPeriod:
                !a.openTime && a.closeDay == 100
                  ? "公休"
                  : a.openTime + " - " + a.closeTime
            });
          }
          this.data = renderData;
          // for (let a of this.data) {
          //   a.createdAt = moment
          //     .unix(a.createdTs)
          //     .format("YYYY-MM-DD HH:mm:ss Z");
          //   a.updatedAt = moment
          //     .unix(a.updatedTs)
          //     .format("YYYY-MM-DD HH:mm:ss Z");
          // }
          return response.data;
        });
    }
  }
};
</script>
